import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Sequences = lazy(() => import('es/app/views/site/sequences'));
const EditSequence = lazy(() => import('es/app/views/site/sequences/edit'));
const EditSequenceForm = lazy(() => import('es/app/views/site/sequences/edit/EditSequence'));
const SequenceExecutionLogs = lazy(() => import('es/app/views/site/sequences/edit/ExecutionLogs'));
const ModelConfigurationStoreProvider = lazy(() => import('es/app/views/site/sequences/edit/ModelConfigurationStore'));

export function SequenceRoutes() {
    return (
        <Route path={siteMap.sequences.search()} element={<Sequences />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={siteMap.sequences.edit().root} element={<EditSequence />}>
                <Route
                    index
                    element={
                        <ModelConfigurationStoreProvider>
                            <EditSequenceForm />
                        </ModelConfigurationStoreProvider>
                    }
                />
            </Route>
            <Route path={siteMap.sequences.create()} element={<EditSequence />}>
                <Route
                    index
                    element={
                        <ModelConfigurationStoreProvider>
                            <EditSequenceForm />
                        </ModelConfigurationStoreProvider>
                    }
                />
            </Route>
            <Route path={siteMap.sequences.edit().executionLogs} element={<EditSequence />}>
                <Route index element={<SequenceExecutionLogs />} />
            </Route>
        </Route>
    );
}
